import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()

export class NavigationService {
  public lastRoutePageDetails: any;   // Holds temporary route data. IMPORTANT: Always reset (set to null or undefined) after it's used to avoid retaining outdated state.

  constructor(private router: Router) {
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  goToLogin() {

    this.router.navigate(['/auth/login']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToSingleTripTrack(pageType: number = 4, typeId: number, tripId: number, vehicleId: number, pageDetails?: any) {
    this.lastRoutePageDetails = {
      ...pageDetails
    }
    this.router.navigate(["/livetrack"], {
      queryParams: {
        pageType,
        typeId,
        tripId,
        vehicleId
      }
    });
  }

  goToSingleLiveTrack(pageType: number = 1, vehicleId: number, pageDetails?: any) {
    this.lastRoutePageDetails = {
      ...pageDetails
    }
    this.router.navigate(["/livetrack"], {
      queryParams: {
        pageType, vehicleId
      }
    });
  }

  goToTripClusterLiveTrack(pageType: number = 4, typeId: number, options?: {
    pageDetails?: any,
    districtId?: number
  }) {
    this.lastRoutePageDetails = {
      ...options.pageDetails
    }
    this.router.navigate(["/livetrack"], {
      queryParams: {
        pageType, typeId, districtId: options?.districtId
      }
    });
  }

  goToClusterLiveTrack(pageType: number = 2, pageDetails?: any) {
    this.lastRoutePageDetails = {
      ...pageDetails
    }
    this.router.navigate(["/livetrack"], {
      queryParams: {
        pageType
      }
    });
  }

  goToDistrictLiveTrack(pageType: number = 3, districtId: number, tripType: number, pageDetails?: any) {
    this.lastRoutePageDetails = {
      ...pageDetails
    }
    this.router.navigate(["/livetrack"], {
      queryParams: {
        pageType, districtId, tripType
      }
    });
  }

  // goToStateLiveTrack(pageType: number = 4, pageDetails?: any) {
  //   this.lastRoutePageDetails = {
  //     ...pageDetails
  //   }
  //   this.router.navigate(["/livetrack", pageType]);
  // }

  goToLastPage() {
    this.lastRoutePageDetails = {
      ...this.lastRoutePageDetails,
      isBack: true
    }
    this.router.navigate([this.lastRoutePageDetails.url]);
  }

  clearLastRouteDetails() {
    this.lastRoutePageDetails = null;
  }

}
